module.exports = __webpack_public_path__ + "static/media/didi_playing_baja.e6ef104f.gif";